module.exports = __webpack_public_path__ + "7a2118fd5b883f0067ecf2335b4a8c58.png";